/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
var trackingUtils = require('../modules/utils/tracking.utils');
var BaggageIncludedTracking = function(enabled) {
    this.enabled = enabled;
    this.any = true;
    this.all = true;
};

Odigeo._.extend(BaggageIncludedTracking.prototype, {
    calculateLabel: function($baggageSegment) {
        if (!this.enabled) {
            return;
        }
        var baggageIncludedType = $baggageSegment.attr('data-baggage');
        if (baggageIncludedType === 'UNKNOWN') {
            this.label = 'unknown';
        } else if (baggageIncludedType === 'CHECK_IN_INCLUDED') {
            this.any = false;
        } else {
            this.all = false;
        }
    },
    getLabel: function() {
        if (!Odigeo._.isUndefined(this.label)) {
            return this.label;
        } else if (this.all) {
            return 'all';
        } else if (this.any) {
            return 'none';
        } else {
            return 'some';
        }
    },
    triggerEventTracking: function() {
        if (!this.enabled) {
            return;
        }
        trackingUtils.trackEventWithCategory('flights_results', 'baggage_information', 'baggage_allowance_select_' + this.getLabel());
    },
});

module.exports = BaggageIncludedTracking;
